<div
	fxLayout="row"
	fxLayout.md="row"
	fxLayout.sm="row wrap"
	fxLayoutAlign.lt-md="space-between"
	fxLayout.lt-sm="column"
	fxFlex="100%"
>
	<div fxFlex="100%" fxFlex.sm="100%" fxFlex.lt-sm="77%" fxLayout.xs="column">
		<div
			fxLayout="row wrap"
			fxLayout.xs="column"
			fxLayoutAlign="space-between baseline"
			ngClass="p-b-m"
		>
			<h2 i18n="@@embed_embedDonation_title">
				Embed donation Widget to your website
			</h2>
			<div
				fxLayout="row"
				fxFlex="100%"
				fxLayoutAlign="start baseline"
				fxLayoutAlign.lt-sm="start space-around"
				fxLayoutGap.lt-sm="5%"
				fxFill
			>
				<div
					fxLayoutAlign="space-between center"
					ngClass="p-xs"
					class="grey-bg"
					fxFlex.gt-md="100%"
					fxFlex.lt-md="100%"
					fxFill
				>
					<div fxLayout="column" fxFlex="90%" fxLayoutAlign="start start">
						<div>
							{{ truncateText(this.shareLink, 100) }}
						</div>
					</div>

					<!--Share Fundraiser-->
					<div
						fxLayout="column"
						fxLayout.lt-sm="row wrap"
						fxFlex="10%"
						fxLayoutAlign="start end"
						fXFlexAlign="start"
					>
						<button
							class="copyLink hover-class"
							mat-icon-button
							matTooltip="{{ matTooltip }}"
							(click)="copyLink()"
						>
							<mat-icon size="3x">content_copy</mat-icon>
						</button>
					</div>
				</div>
			</div>
		</div>
		<form [formGroup]="pluginForm">
			<p>
				<mat-slide-toggle
					class="mat-subtitle-2"
					color="primary"
					formControlName="hideWidgetCard"
					(change)="setWidgetCheckbox($event)"
				>
					<span i18n="@@widget_form_show_donate_button_only">Show card</span>
				</mat-slide-toggle>
			</p>
			<p>
				<mat-slide-toggle formControlName="showImageCheckbox" color="primary"
					><span i18n="@@widget_form_show_main_image" class="mat-subtitle-2"
						>Show Main image</span
					></mat-slide-toggle
				>
			</p>
			<p>
				<mat-slide-toggle formControlName="addFormCheckbox" color="primary"
					><span i18n="@@embed_addDonationForm_checkbox" class="mat-subtitle-2"
						>Add Donation form</span
					></mat-slide-toggle
				>
			</p>
			<div class="m-t-m" id="customise-branding">
				<mat-accordion>
					<mat-expansion-panel class="mat-elevation-z0">
						<mat-expansion-panel-header [style.paddingLeft.px]="0">
							<mat-panel-title>
								<h2 i18n="@@stepsWidgetStyling_title" for="donation-form-label">
									Styling
								</h2>
							</mat-panel-title>
						</mat-expansion-panel-header>
						<div
							fxLayout="row"
							class="m-t-s m-b-s"
							fxLayoutAlign="start center"
						>
							<div fxLayout="row" fxLayoutGap="4%" fxFill>
								<div fxLayout="column" fxLayoutAlign="center center">
									<p i18n="@@custom-branding-cardShadow">Card Shadow</p>
								</div>
								<div ngClass="p-b-m">
									<mat-card class="mat-elevation-z{{ previewBoxShadowNumber }}">
										<mat-card-content>
											<mat-button-toggle-group
												formControlName="boxShadowNumber"
												(change)="updateBoxShadow()"
												class="custom-button-toggle-group"
											>
												<mat-button-toggle
													[value]="1"
													i18n="@@widget_form_card_shadow_none"
													>None</mat-button-toggle
												>
												<mat-button-toggle
													[value]="2"
													i18n="@@custom-branding-card-shadow-medium"
													>Medium
												</mat-button-toggle>
												<mat-button-toggle
													[value]="4"
													i18n="@@custom-branding-card-shadow-high"
													>High
												</mat-button-toggle>
											</mat-button-toggle-group>
										</mat-card-content>
									</mat-card>
								</div>
							</div>
						</div>

						<div id="set-color">
							<mat-form-field
								fxFlex="50"
								appearance="outline"
								floatLabel="always"
								color="primary"
							>
								<mat-label i18n="@@custom-branding-set-primary-color-label"
									>Primary Color</mat-label
								>
								<input
									matInput
									type="text"
									placeholder="Ex. #ffff"
									formControlName="currentPrimaryColor"
									(change)="updatePrimaryColorFromInput($event)"
								/>
								<button matSuffix mat-icon-button>
									<mat-icon class="material-icons-outlined">
										<input
											[style.cursor]="'pointer'"
											matInput
											type="color"
											formControlName="currentPrimaryColor"
											(input)="updatePrimaryColorFromColorPicker($event)"
										/>
									</mat-icon>
								</button>
							</mat-form-field>
							<mat-form-field
								fxFlex="50"
								class="m-l-s"
								appearance="outline"
								floatLabel="always"
								color="primary"
							>
								<mat-label i18n="@@custom-branding-set-secondary-color-label"
									>Secondary Color</mat-label
								>
								<input
									matInput
									type="text"
									placeholder="Ex. #ffff"
									formControlName="currentSecondaryColor"
									(change)="updateSecondaryColorFromInput($event)"
								/>
								<button matSuffix mat-icon-button>
									<mat-icon class="material-icons-outlined">
										<input
											[style.cursor]="'pointer'"
											matInput
											type="color"
											formControlName="currentSecondaryColor"
											(input)="updateSecondaryColorFromColorPicker($event)"
										/>
									</mat-icon>
								</button>
							</mat-form-field>
						</div>
						<div>
							<mat-form-field fxFlex="50" appearance="outline">
								<mat-label i18n="@@widget_form_typography" for="selectTypo"
									>Typography</mat-label
								>
								<mat-select
									formControlName="widgetFontName"
									id="selectTypo"
									(selectionChange)="changeFontFamily()"
								>
									<mat-option
										*ngFor="let font of fontList"
										[ngStyle]="{ 'font-family': font }"
										[value]="font"
									>
										{{ font }}
									</mat-option>
								</mat-select>
								<mat-hint
									class="error-text"
									align="end"
									*ngIf="pluginForm.get('widgetFontName')?.value === ''"
								>
									<span i18n="@@widget_form_select_font_matError"
										>Please select a font</span
									>
								</mat-hint>
							</mat-form-field>

							<!-- Button Radius Selection -->
							<mat-form-field
								fxFlex="50"
								appearance="outline"
								color="primary"
								class="m-l-s"
							>
								<mat-label
									for="set-button-radius-label"
									i18n="@@widget_form_button_radius"
									>Button Radius</mat-label
								>
								<input
									matInput
									type="number"
									min="0"
									max="30"
									formControlName="currentButtonRadius"
									(change)="onchangeButtonRadius()"
								/>
								<mat-hint
									class="error-text"
									align="end"
									*ngIf="
										pluginForm.get('currentButtonRadius')?.value < 0 ||
										pluginForm.get('currentButtonRadius')?.value > 30
									"
								>
									<span i18n="@@widgetform_range_matError"
										>Range is between 0 to 30</span
									>
								</mat-hint>
							</mat-form-field>
						</div>
					</mat-expansion-panel>
				</mat-accordion>
			</div>
			<p class="mat-subtitle-2" i18n="@@embed_copyAndPaste_label">
				Copy and paste the following embed code:
			</p>

			<div fxLayoutGap="5%">
				<div fxFlex fxLayout="row" class="grey-bg">
					<div ngClass="p-m" contenteditable="false">
						{{ embedHTML }}
					</div>
					<div
						fxLayoutAlign="end center"
						class="p-r-xs"
						[style.marginTop.px]="this.media.isActive('gt-sm') ? '-8' : '0'"
					>
						<button
							class="copyLink hover-class"
							mat-icon-button
							matTooltip="{{ matTooltip }}"
							[cdkCopyToClipboard]="copyEmbedHTML()"
						>
							<mat-icon size="3x">content_copy</mat-icon>
						</button>
					</div>
				</div>
			</div>
		</form>
	</div>
	<!-- <mat-divider vertical="true"></mat-divider> -->
</div>
